import { store } from "@/store/index"
import axios from "axios"
let config = null

export const targetObjToString = (obj = 0) => {
    const measure = obj.measure ? obj.measure : ""
    const group = obj.group ? obj.group : ""
    const age_from = obj.age_from ? obj.age_from : ""
    const age_to = obj.age_to ? obj.age_to : ""
    const consolidation = obj.consolidation ? obj.consolidation : ""
    const targetString = measure + ", " + group + age_from + "-" + age_to + ", " + consolidation

    return targetString
}

export const appendTargetCols = (query, data) => {
    return data.map(item => {
        query.target_group.map(target => {
            item[targetObjToString(target)] = 0
        })
        return item
    })
}
export function dateToyymmddFormat(item) {
    if (item == null) return ""

    let date = new Date(item)
    return date.toLocaleDateString("sv-SE", {})
}

export function dateToTimeStamp(item) {
    if (item == null) return null
    let date = new Date(item)
    return date.toLocaleTimeString("sv-SE", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    })
}
export function download(content, filename, contentType) {
    if (!contentType) contentType = "application/octet-stream"
    let a = document.createElement("a")
    content = "\ufeff" + content
    let blob = new Blob([content], { type: contentType })
    a.href = window.URL.createObjectURL(blob)
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(a.href) //Release the blob object
}
function overlapping(a, b) {
    const getMinutes = s => {
        const p = s.split(":").map(Number)
        return p[0] * 60 + p[1]
    }
    return getMinutes(a.end) > getMinutes(b.start) && getMinutes(b.end) > getMinutes(a.start)
}
export function isOverlapping(arr) {
    let i, j
    for (i = 0; i < arr.length - 1; i++) {
        for (j = i + 1; j < arr.length; j++) {
            let previousTime = arr[i].daypart.split("-")
            let nextTime = arr[j].daypart.split("-")
            if (overlapping({ start: previousTime[0], end: previousTime[1] }, { start: nextTime[0], end: nextTime[1] })) {
                return true
            }
        }
    }
    return false
}
export function compareNumbers(a, b) {
    return a - b
}
export const objectArraysEqual = (o1a, o2a) => {
    let objectArraysEqual = o1a.length !== o2a.length ? false : true
    if (objectArraysEqual) {
        for (let i = 0; i < o1a.length; i++) {
            objectArraysEqual = Object.keys(o1a[i]).length === Object.keys(o2a[i]).length && Object.keys(o1a[i]).every(p => o1a[i][p] === o2a[i][p])
        }
    }
    return objectArraysEqual
}
export function arraysEqual(a, b) {
    if (a === b) return true
    if (a == null || b == null) return false
    if (a.length !== b.length) return false
    a.sort()
    b.sort()
    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false
    }
    return true
}
export function isDateNotBetweenTwoDates(isThisDateBetween, datefrom, dateto) {
    datefrom.setHours(0, 0, 0)
    dateto.setHours(0, 0, 0)
    isThisDateBetween.setHours(0, 0, 0)
    if (isThisDateBetween.getTime() <= dateto.getTime() && isThisDateBetween.getTime() >= datefrom.getTime()) return false
    return true
}
export function scrollToBottom() {
    setTimeout(function() {
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
    }, 10)
}
export function daysBetweenDates(startDate, endDate) {
    var millisecondsPerDay = 24 * 60 * 60 * 1000
    return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay

    function treatAsUTC(date) {
        var result = new Date(date)
        result.setMinutes(result.getMinutes() - result.getTimezoneOffset())
        return result
    }
}
export function sortResultTable(sortInfo, sortItems) {
    //sort numeric
    if (sortInfo.isNumber && sortInfo.sortDesc) {
        sortItems.sort((a, b) => {
            let sortByA = a[sortInfo.sortBy].replace(/ /g, "")
            let sortByB = b[sortInfo.sortBy].replace(/ /g, "")
            if (sortByB == "") return -1
            if (typeof a[sortInfo.sortBy] === "string") sortByA = parseFloat(a[sortInfo.sortBy].replace(/,/g, ".").replace(/\s/g, ""))
            if (typeof b[sortInfo.sortBy] === "string") sortByB = parseFloat(b[sortInfo.sortBy].replace(/,/g, ".").replace(/\s/g, ""))
            return sortByB - sortByA
        })
    } else if (sortInfo.isNumber && !sortInfo.sortDesc) {
        sortItems.sort((a, b) => {
            let sortByA = a[sortInfo.sortBy].replace(/ /g, "")
            let sortByB = b[sortInfo.sortBy].replace(/ /g, "")
            if (sortByA == "") return -1
            if (typeof a[sortInfo.sortBy] === "string") sortByA = parseFloat(a[sortInfo.sortBy].replace(/,/g, ".").replace(/\s/g, ""))
            if (typeof b[sortInfo.sortBy] === "string") sortByB = parseFloat(b[sortInfo.sortBy].replace(/,/g, ".").replace(/\s/g, ""))
            return sortByA - sortByB
        })
    }
    //regular sort
    else sortItems.sort(dynamicSort(sortInfo))
    return sortItems
}
export function dynamicSort(sortInfo) {
    var sortOrder = 1
    if (sortInfo.sortDesc) sortOrder = -1
    return function(a, b) {
        var result = a[sortInfo.sortBy] < b[sortInfo.sortBy] ? -1 : a[sortInfo.sortBy] > b[sortInfo.sortBy] ? 1 : 0
        return result * sortOrder
    }
}
//startdate the highest number between first pubdate content or ad
//enddate the lowest number between last pubdate content or ad
export function getChannelDatePeriod(getters) {
    let publishFromDate = new Date(getters.getPublishedFromDate)
    let adFromDate = new Date(getters.getMetadataAdFromDate)
    let fromDates = []
    fromDates.push(publishFromDate, adFromDate)
    let fromDate = new Date(Math.max.apply(null, fromDates))
    let toDates = []
    let publishToDate = new Date(getters.getPublishedToDate)
    let adToDate = new Date(getters.getMetadataAdToDate)
    toDates.push(publishToDate, adToDate)
    let toDate = new Date(Math.min.apply(null, toDates))
    return { fromDate: dateToyymmddFormat(fromDate), endDate: dateToyymmddFormat(toDate) }
}
export function checkCookieConsent() {
    const consentCookie = document.cookie.split("; ").find(row => row.startsWith("MMS_UserConsentStatus_Totalanalys="))

    return consentCookie ? true : false
}
export function consentToCookies() {
    const date = new Date()
    date.setMonth(date.getMonth() + 3)
    const cookieDomain = store.getters.getAppCookieDomain
    document.cookie = `MMS_UserConsentStatus_Totalanalys=true; expires=${date.toUTCString()}; domain=${cookieDomain}; path=/; Secure; SameSite=Lax`
}

export async function determineApiVersion(date, controllerType) {
    const startDate = new Date(date)
    if (!config) {
        config = await axios.get("./config/runtime.json").then(conf => conf.data)
    }
    const ToV3ChangeDate = new Date(config.ToV3ChangeDate)
    if (controllerType === "ads") {
        if (startDate < ToV3ChangeDate) {
            return { apiVersion: "2", appVersion: "2", controllerVersion: "1" } // TotalAnalys (v2 GFK), controller version v1
        } else {
            return { apiVersion: "3", appVersion: "2", controllerVersion: "2" } // TotalAnalys (v2 GFK), controller version v2
        }
    } else if (controllerType === "programs" || controllerType === "sites") {
        if (startDate < ToV3ChangeDate) {
            return { apiVersion: "1", appVersion: "1", controllerVersion: "1" } // TotalAnalys (v1), controller version v1
        } else {
            return { apiVersion: "3", appVersion: "2", controllerVersion: "2" } // TotalAnalys (v2 GFK), controller version v2
        }
    } else {
        // Fallback
        return { apiVersion: "3", appVersion: "2", controllerVersion: "2" }
    }
}
